/**
 * 调度服务环境调用
 */

import { pageArgs } from '@/utils'

// 运行环境
const ENV = process.env.NODE_ENV
// 服务器名称
// let hostname

// 获取主机环境
const getHostType = () => {
  if (ENV === 'development') return 'dev'
  if (ENV === 'production') return 'prod'
  return 'prod'
}

// 服务配置
const urlServer = {
  mock: '',
  dev: `https://app-ylsn-dev.ylyk.com`, // 开发接口
  localhost: 'http://localhost:8082', // 本地
  'test:xhl': 'http://192.168.9.10:8082', // 集成环境
  test: `https://app-ylsn-test.ylyk.com`, // 测试环境
  // test: `https://app-ylsn.ylyk.com`, // 测试环境访问正式
  // test: `http://172.18.10.244:8182`, // 测试环境-徐海龙
  pre: `https://app-ylsn-pre.ylyk.com`, // 预生产环境
  prod: `https://app-ylsn.ylyk.com` // 生产环境
}

const getURL = custom => {
  return urlServer[custom || getHostType()]
}
const getModule = (custom, module) => {
  if (typeof module === 'string') {
    return module
  }
  const hostType = custom.split(':').shift() || getHostType()
  return module[hostType] || module['prod'] || module['dev']
}

// 获取主机环境
let _defaultPort = null
export const getDefaultPort = () => {
  if (_defaultPort != null) {
    return _defaultPort
  }
  if (process.env.NODE_ENV === 'production') {
    if (location.href.indexOf('-test.ylyk.com') > 0 || location.href.indexOf('ylyk.com/test/') > 0) {
      _defaultPort = 'test'
    } else if (location.href.indexOf('-dev.ylyk.com') > 0 || location.href.indexOf('ylyk.com/dev/') > 0) {
      _defaultPort = 'dev'
    } else if (location.href.indexOf('-pre.ylyk.com') > 0 || location.href.indexOf('ylyk.com/pre/') > 0) {
      _defaultPort = 'pre'
    } else {
      _defaultPort = 'prod'
    }
  } else {
    // _defaultPort = 'dev'
    _defaultPort = 'test'
  }
  return _defaultPort
}

// 获取请求地址
export default {
  path(custom, module, urlMap) {
    let _url = getURL(custom)
    let _module = getModule(custom, module)
    return name => {
      // 开发环境时，优先使用动态配置
      if (custom !== 'prod' && custom.indexOf('test:') === -1) {
        const args = pageArgs.args()
        const { module: moduleName } = module || {}
        // 获取动态配置
        if (args && args.port) {
          const port = args.port
          // > 先读取设置的环境
          const defaultPort = port['default'] || getDefaultPort() // 设置默认线上服务
          // > 在读取单个模块的环境
          const customNew = port[moduleName] || defaultPort
          if (customNew) {
            _url = getURL(customNew) || _url
            _module = getModule(customNew, module) || _module
          }
        }
      }
      // 获取接口
      const action = (urlMap && name && urlMap[name]) || name
      return `${_url}/${_module}/${action}`
    }
  }
}
